module.exports = __webpack_public_path__ + "static/netcompany-map-2-7867730f614a219aed72d371e9f4b361.png";